import { defineRouter } from '#q-app'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'
import store from '@/store'

export default defineRouter(function (/* { ssrContext } */) {
  const createHistory = import.meta.env.QUASAR_SERVER
    ? createMemoryHistory
    : (import.meta.env.QUASAR_VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createHistory(import.meta.env.QUASAR_MODE === 'ssr' ? undefined : import.meta.env.QUASAR_VUE_ROUTER_BASE)
  })

  // Vue Router 4+/5 style: return the navigation result instead of calling next()
  Router.beforeEach(async (to, from) => {
    const authenticated = store.state.User.authenticated
    const requiresAuth = to.matched.some((record) => record.meta && record.meta.requiresAuth)
    const requiresUnAuth = to.matched.some((record) => record.meta && record.meta.requiresUnAuth)
    const hasFlash = to.matched.some((record) => record.meta && record.meta.hasFlash)
    store.commit('Flash/SET_PAGE_SPECIFIC', hasFlash)
    if (requiresAuth && !authenticated) {
      let loggedIn = false
      try {
        loggedIn = await store.dispatch('User/get')
      } catch (ex) {
      }
      if (loggedIn) {
        return true
      }
      const loginpath = to.fullPath
      if (loginpath.match(/logout|login/)) {
        return { name: 'Login' }
      }
      return { name: 'Login', query: { from: loginpath } }
    } else if (requiresUnAuth && authenticated) {
      return { name: 'Home' }
    }
    return true
  })
  return Router
})
